module.exports = __webpack_public_path__ + "img/serve5.7811b02b.png";